import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import ForcePassword from './ForcePassword';

import Button from '../../../components/button';
import Auth from '../../../utils/Auth';
import { getBackendBaseUrl, fetchBackendUrl } from '../../../constants';
import styles from './forceChange.module.scss';
import { fetchChangePin } from '../../../components/topbar/profile/redux/actions';

class ForceChangePasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: '',
      confirmPassword: '',
      passwordMatches: true,
      flag: true,
      errors: {
        newPasswordEmpty: true,
        confirmPasswordEmpty: true,
        invalidPassword: false
      }
    };
  }

  validateFormFields = (inputType, value) => {
    const errors = {};
    switch (inputType) {
      case 'newPassword':
        if (value === '') {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { newPasswordEmpty: true })
          }));
        } else {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { newPasswordEmpty: true })
          }));
        }
        break;
      case 'confirmPassword':
        if (value === '') {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { confirmPasswordEmpty: true })
          }));
        } else {
          this.setState(prevState => ({
            errors: Object.assign({},
              prevState.errors,
              { confirmPasswordEmpty: true })
          }));
        }
        break;
      default:
        break;
    }
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, errors)
    }));
  }

  handleInputChange = (inputType, value) => {
    this.setState({
      [inputType]: value
    }, () => this.validateFormFields(inputType, value));
  }

  checkEmptyFields = () => {
    const {
        newPassword,
         confirmPassword
         } = this.state;
    if (newPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          newPasswordEmpty: false
        })
      }));
    }
    if (confirmPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          confirmPasswordEmpty: false
        })
      }));
    }
  }

  checkPasswordMatch = () => {
    const { newPassword, confirmPassword } = this.state;

    if (newPassword !== '' && confirmPassword !== '') {
      this.setState({
        passwordMatches: (newPassword === confirmPassword), flag: false
      });
    } else {
      this.setState({ passwordMatches: true });
    }
  }

  handleForcedPasswordChange = () => {
    const { newPassword, confirmPassword, passwordMatches, flag } = this.state;
    const { cognitoUser, history } = this.props;
    this.checkPasswordMatch();
    if (!passwordMatches) {
      return;
    }
    if (newPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          newPasswordEmpty: false
        })
      }));
      return;
    }
    if (confirmPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          confirmPasswordEmpty: false
        })
      }));
      return;
    }
    const decimal= /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/.test(newPassword);
    if (!decimal && !flag) {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          invalidPassword: true
        })
      }));
    } else {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, {
          invalidPassword: false
        })
      }));
      cognitoUser.completeNewPasswordChallenge(newPassword, [], {
        onSuccess: (result) => {
          Auth.getInstance().setAuthToken(result.getAccessToken().getJwtToken());
          Auth.getInstance().setIDToken(result.getIdToken().getJwtToken());
          let token = result.getIdToken().getJwtToken().split('.')[1];
          token = Buffer.from(token, 'base64').toString();
          localStorage.setItem('userId', JSON.parse(token)['cognito:username']);
          fetchBackendUrl()
            .then(() => {
              axios.defaults.baseURL = getBackendBaseUrl();
            })
            .then(() => {
              history.push('/');
              window.location.reload();
            })
            .catch((err) => {
              // eslint-disable-next-line no-console
              console.log(err);
            });
        },
        onFailure: this.handleAuthError
      });
    }
  }

  render() {
    const { errors, passwordMatches } = this.state;
    return (
      <div className={styles.content}>
          <ForcePassword
            checkEmptyFields={this.checkEmptyFields}
            handleInputChange={this.handleInputChange}
            checkPasswordMatch={this.checkPasswordMatch}
            newPasswordEmpty={errors.newPasswordEmpty}
            confirmPasswordEmpty={errors.confirmPasswordEmpty}
            passwordMatches={passwordMatches}
            invalidPassword={errors.invalidPassword}
          />
        <div className={styles.footer}>
            <div className={styles.submitPassword}>
                <Button action="secondary" onClick={this.handleForcedPasswordChange} contentStyles={{ float: 'right' }}
                translationID="general.login.changePassword" defaultText="Change Password"
                />
            </div>
        </div>
      </div>
    );
  }
}

ForceChangePasswordForm.propTypes = {
  actionFetchChangePin: PropTypes.func.isRequired
};
const mapDispatchToProps = dispatch => ({
  actionFetchChangePin: (data) => {
    dispatch(fetchChangePin(data));
  }
});

export default connect(null, mapDispatchToProps)(withRouter(ForceChangePasswordForm));
